import {Injectable} from '@angular/core';
import {CacheStore} from './cache-store';
import {RequestCacheEntry} from './request-cache-entry';

/**
 * A cache store implementation storing cache entries in the browsers session storage.
 */
@Injectable()
export class SessionStorageCacheStore implements CacheStore {
    get(key: string): RequestCacheEntry | undefined {
        const cached = sessionStorage.getItem(key);

        if (!cached) {
            return undefined;
        }

        return JSON.parse(cached);
    }

    delete(key: string): void {
        sessionStorage.removeItem(key);
    }

    put(key: string, cacheEntry: RequestCacheEntry): void {
        sessionStorage.setItem(key, JSON.stringify(cacheEntry));
    }
}
